import React from "react";
import { Box, Button } from "@mui/material";
import { Theme } from "@mui/material/styles";
import { Subcategory } from "../../services/subcategories";

interface SubcategoriesBarProps {
  theme: Theme;
  activeCategory: string;
  subcategories: Subcategory[];
  language: string;
  onSubcategoryClick: (categoryKey: string) => void;
}

const SubcategoriesBar: React.FC<SubcategoriesBarProps> = ({
  theme,
  activeCategory,
  subcategories,
  language,
  onSubcategoryClick,
}) => {
  const visible = subcategories.filter(
    (s) => s.category_key === activeCategory && s.is_active
  );

  if (!activeCategory || visible.length === 0) return null;

  const getLabel = (sub: Subcategory) => {
    if (language === "ar") return sub.label_ar || sub.label_en || sub.key;
    if (language === "fr") return sub.label_fr || sub.label_en || sub.key;
    return sub.label_en || sub.key;
  };

  return (
    <Box
      sx={{
        backgroundColor:
          theme.palette.mode === "dark"
            ? "rgba(0, 212, 255, 0.03)"
            : "rgba(32, 32, 32, 0.08)",
        borderTop:
          theme.palette.mode === "dark"
            ? "1px solid rgba(255,255,255,0.05)"
            : "1px solid rgba(0,0,0,0.06)",
        width: "100%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 0.5,
          py: 0.75,
          px: { xs: 1.5, sm: 2 },
          overflowX: "auto",
          justifyContent: { xs: "flex-start", md: "center" },
          "&::-webkit-scrollbar": {
            height: 2,
            display: { xs: "block", md: "none" },
          },
          "&::-webkit-scrollbar-thumb": {
            bgcolor: "rgba(255,255,255,0.15)",
            borderRadius: 8,
          },
        }}
      >
        {visible.map((sub) => (
          <Button
            key={sub.id}
            size="small"
            onClick={() => onSubcategoryClick(activeCategory)}
            sx={{
              color: theme.palette.text.secondary,
              px: { xs: 1.25, sm: 1.75 },
              py: { xs: 0.2, sm: 0.4 },
              minHeight: { xs: 24, sm: 28 },
              fontSize: { xs: "0.7rem", sm: "0.8rem" },
              borderRadius: "20px",
              border: "1px solid transparent",
              whiteSpace: "nowrap",
              "&:hover": {
                bgcolor: "rgba(0,212,255,0.1)",
                color: "#00d4ff",
                border: "1px solid rgba(0,212,255,0.3)",
              },
            }}
          >
            {getLabel(sub)}
          </Button>
        ))}
      </Box>
    </Box>
  );
};

export default SubcategoriesBar;
